import React from 'react'
import useSelector from 'hooks/use-selector'
import getCurrentMemberSquadSelect from 'modules/squad/redux/selectors/get-current-member'
import SquadPageSuperLikedSamples from 'pages/Squad/containers/SuperLikedSamples'
import logUtil from 'utils/log'

export default function SquadPageCurrentFriendSuperLikedSamples () {
  /**
   * @type import('modules/squad/types').SquadMemberInfo
   */
  const currentMember = useSelector(getCurrentMemberSquadSelect)
  const currentMemberId = currentMember?.squad_member_customer_id

  const debugProps = {
    currentMember
  }
  logUtil('SquadPageCurrentFriendSuperLikedSamples').debug('debugProps=', debugProps)
  return (
    <SquadPageSuperLikedSamples
      id={currentMemberId}
      name={currentMember?.squad_member_first_name}
    />
  )
}
